import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "../store";

type CampgroundLayerState = {
  visible: boolean;
};

const initialState: CampgroundLayerState = {
  visible: true, // Default to visible to maintain current behavior
};

const campgroundLayer = createSlice({
  name: "campgroundLayer",
  initialState,
  reducers: {
    setCampgroundsVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    toggleCampgroundsVisible: (state) => {
      state.visible = !state.visible;
    },
  },
});

export const { setCampgroundsVisible, toggleCampgroundsVisible } =
  campgroundLayer.actions;

export default campgroundLayer.reducer;

// Selector
const selectCampgroundsVisible = (state: RootState) =>
  state.campgroundLayer.visible;

export const useCampgroundsVisible = () => {
  return useSelector(selectCampgroundsVisible);
};
